import axios from "axios";
import {SweetAlertBasic} from "../../sweetAlert";
import {
  getFallas,
  getStatusTicket,
  getTicketsDet,
  getTipoReq,
  getTipoTicket,
  getTotalesRT
} from "../../api/reportes-tickets";


export function getCatFallas() {
  return async (dispatch) => {
      getFallas().then(response => {
        dispatch(fallaCatSuccess(response));
      }).catch (error => {
      dispatch(reportesTicketsError(error));
      SweetAlertBasic('error', 'Algo salio mal', 'Vuelve a intentarlo más tarde');
    })
  };
}

export function getCatStatus() {
  return async (dispatch) => {
    getStatusTicket().then(response => {
      dispatch(statusCatSuccess(response));
    }).catch (error => {
      dispatch(reportesTicketsError(error));
      SweetAlertBasic('error', 'Algo salio mal', 'Vuelve a intentarlo más tarde');
    })
  };
}

export function getCatTipoTicket() {
  return async (dispatch) => {
    getTipoTicket().then(response => {
      dispatch(tipoTCatSuccess(response));
    }).catch (error => {
      dispatch(reportesTicketsError(error));
      SweetAlertBasic('error', 'Algo salio mal', 'Vuelve a intentarlo más tarde');
    })
  };
}

export function getCatTipoReq() {
  return async (dispatch) => {
    getTipoReq().then(response => {
      dispatch(tipoReqCatSuccess(response));
    }).catch (error => {
      dispatch(reportesTicketsError(error));
      SweetAlertBasic('error', 'Algo salio mal', 'Vuelve a intentarlo más tarde');
    })
  };
}

export function getTotalesRepT(){
  return async (dispatch) => {
    getTotalesRT().then(response => {
      dispatch(totalesSuccess(response));
    }).catch (error => {
      dispatch(reportesTicketsError(error));
      SweetAlertBasic('error', 'Algo salio mal', 'Vuelve a intentarlo más tarde');
    })
  };
}

export function getTicketsD(filters){
  return async (dispatch) => {
    getTicketsDet(filters).then((response) => {
      dispatch(ticketsSuccess(response));
    }).catch (error => {
      dispatch(reportesTicketsError(error));
      SweetAlertBasic('error', 'Algo salio mal', 'Vuelve a intentarlo más tarde');
    })
  };
}

export const reportesTicketsInit = () => ({ type: 'VIEW_REPORTES_TICKETS_INIT' });
const reportesTicketsError = (error) => ({ type: 'VIEW_REPORTES_TICKETS_ERROR', payload: error });
const fallaCatSuccess = (data) => ({ type: 'VIEW_FALLAS_SUCCESS', payload: data });
const statusCatSuccess = (data) => ({ type: 'VIEW_STATUS_SUCCESS', payload: data });
const tipoTCatSuccess = (data) => ({ type: 'VIEW_TIPO_TICKET_SUCCESS', payload: data });
const tipoReqCatSuccess = (data) => ({ type: 'VIEW_TIPO_REQ_SUCCESS', payload: data });
const totalesSuccess = (data) => ({ type: 'VIEW_TOTALES_SUCCESS', payload: data });
const ticketsSuccess = (data) => ({ type: 'VIEW_TICKETS_SUCCESS', payload: data });


const initialState = {
  name: 'reportesTickets',
  state: false,
  loading: true,
  fallas:[],
  statusTicket:[],
  tipoTicket:[],
  tipoReq:[],
  totales:[],
  tickets:[],
};

export default function init(state = initialState, action) {
  switch (action.type) {
    case "VIEW_REPORTES_TICKETS_INIT":
      return {
        ...state,
        loading: true,
      };
    case 'VIEW_FALLAS_SUCCESS':
      return {
        ...state,
        state: true,
        loading: false,
        fallas: action.payload,
      };
    case 'VIEW_STATUS_SUCCESS':
      return {
        ...state,
        state: true,
        loading: false,
        statusTicket: action.payload,
      };
    case 'VIEW_TIPO_TICKET_SUCCESS':
      return {
        ...state,
        state: true,
        loading: false,
        tipoTicket: action.payload,
      };
    case "VIEW_TIPO_REQ_SUCCESS":
      return {
        ...state,
        loading: true,
        tipoReq: action.payload,
      };
    case "VIEW_REPORTES_TICKETS_ERROR":
      return {
        state: false,
        loading: true,
        error: action.payload,
      };
    case "VIEW_TOTALES_SUCCESS":
      return {
        ...state,
        loading: true,
        totales: action.payload,
      };
    case "VIEW_TICKETS_SUCCESS":
      return {
        ...state,
        loading: false,
        tickets: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
}

